import { Divider, Stack, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import FHConfirmDialog from '../../../../../../components/base/dialogs/FHConfirmDialog';
import { FORTA_ERROR, FORTA_GRAY5 } from '../../../../../../utils/colors';

import type { ConcludeConfirmModalProps } from './types';

function renderTitle() {
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <WarningAmberRoundedIcon sx={{ color: FORTA_ERROR }} />
        <Typography variant="h4" fontWeight={500}>
          Are you sure you want to conclude?
        </Typography>
      </Stack>
      <Divider sx={{ mt: 2 }} />
    </>
  );
}

function renderContent() {
  return (
    <Typography sx={{ color: FORTA_GRAY5, fontSize: 14, pt: 3 }}>
      Once you conclude this Client Onboarding, you will not be able to make any further changes.
    </Typography>
  );
}

export default function ConcludeConfirmModal({
  open,
  submitLoading,
  onClose,
  onSubmit,
}: ConcludeConfirmModalProps) {
  return (
    <FHConfirmDialog
      open={open}
      hideCloseIcon
      submittext="Conclude"
      canceltext="Cancel"
      submitLoading={submitLoading}
      onClose={onClose}
      onSubmit={onSubmit}
      dialogHeight="auto"
      footerContainerStyles={{ justifyContent: 'space-between', mt: 4 }}
      submitBtnTestId="conclude-confirm-submit"
      cancelBtnTestId="conclude-confirm-cancel"
      titleRenderer={renderTitle}
      contentRenderer={renderContent}
    />
  );
}
